import { useEffect, useState } from "react";

// Matches macaw-ui's "mobile" breakpoint (its "tablet" sprinkles start at 768px).
const MOBILE_MEDIA_QUERY = "(max-width: 767px)";

const getMatches = (): boolean =>
  typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(MOBILE_MEDIA_QUERY).matches
    : false;

/**
 * True on phone-sized viewports. Used to swap canvas datagrids, which are hard
 * to use with touch, for simple stacked lists.
 */
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(getMatches);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") {
      return;
    }

    const mediaQueryList = window.matchMedia(MOBILE_MEDIA_QUERY);
    const handleChange = () => setIsMobile(mediaQueryList.matches);

    handleChange();
    mediaQueryList.addEventListener("change", handleChange);

    return () => mediaQueryList.removeEventListener("change", handleChange);
  }, []);

  return isMobile;
};
